import React, {lazy} from 'react'
import { Timeline, TimelineConnector, TimelineContent, TimelineItem, TimelineSeparator } from '@mui/lab';
import { HourInterface } from './DayTimeline';
import { IonButton, IonCard, IonChip, IonGrid, IonIcon, IonRow, isPlatform } from '@ionic/react';
import { addCircle, calendar } from 'ionicons/icons';
import dayjs from 'dayjs';
import { formatEnd } from '../../helpers/format_date';
import Api from "../../services/Api"
import { goToPageWithState } from '../../helpers/app_actions';
import { CalendarInterface } from '../WalkCalendar';
const WalkPreview = lazy(() => import('./WalkPreview'))

type ComponentProps = {
  hour: HourInterface
  selectedDay: Date
  events: any[]
  calendars: Array<CalendarInterface>
  setCal: number
  create?: boolean
  setTimePicker?: Function
}

const TimelineComponent = ({ hour, selectedDay, events, calendars, setCal, create, setTimePicker } : ComponentProps) => {
  const api = Api.getInstance();

  const sortWalks = () => {
    const walks = hour.walks.sort((a, b ) => new Date(a.start).getTime() - new Date(b.start).getTime())
    return walks
  }

  const sortEvents = () => {
    const event = events.sort((a, b ) => new Date(isPlatform('android') ? a.dtstart : a.startDate).getTime() - new Date(isPlatform('android') ? b.dtstart : b.startDate).getTime())
    return event
  }

  const hourComp = () => {
    if(hour.walks.length > 0) {
      return <Timeline position="right" className="fullWidth" >
      { sortWalks().map((walk, index) => {
        return <TimelineItem className="fullWidth" key={index}>
        <TimelineSeparator>
          <IonChip class="p-2" color="teal">
            {dayjs(walk.start).format('HH:mm')}
          </IonChip>
          <TimelineConnector /> 
          <p className="font_small mb-2 color_grey">{formatEnd(walk.start, walk.lengthMinutes)}</p>
        </TimelineSeparator>
        <TimelineContent>
          <WalkPreview item={walk} setCal={setCal} calendars={calendars} isSync={true}/>
        </TimelineContent> 
      </TimelineItem>
    })}
    </Timeline>
    }
  }

  const eventComp = () => {

      return <Timeline position="right" className="fullWidth" >
      { sortEvents().map((ev, index) => {
        return <TimelineItem className="fullWidth" key={index}>
        <TimelineSeparator>
          <IonChip class="p-2" color="teal">
            { isPlatform('android') ? 
            dayjs(ev.dtstart).format('HH:mm')
            : 
            dayjs(ev.startDate).format('HH:mm')
            }
          </IonChip>
          <TimelineConnector /> 
          <p className="font_small mb-2 color_grey">
            {isPlatform('android') ?
              dayjs(ev.dtend).format('HH:mm')
            :
              dayjs(ev.endDate).format('HH:mm')
            }
          </p>
        </TimelineSeparator>
        <TimelineContent>
          <IonCard class="p-2 m-2 bg_grey">
            <IonGrid>
              <IonRow>
                <article className="font_small color_grey flex items-center">
                  <IonIcon icon={calendar}/>
                  <p className="ml-2 color_grey">
                    { api.lang === 'sv' ? 'Från din kalender' : 'From your calendar'}
                  </p>
                </article>
              </IonRow>
              <IonRow>
                {/* {ev.title} */}
                {api.lang === 'sv' ? 'Upptagen tid' : 'Occupied time'}
              </IonRow>
            </IonGrid>
          </IonCard>
        </TimelineContent> 
      </TimelineItem>
    })}
    </Timeline>
  }

  const noEvent = () => {
    return <Timeline position="right" className="fullWidth" 
    // onResize={undefined} onResizeCapture={undefined}
    >
    <TimelineItem className="fullWidth">
      <TimelineSeparator>
        <IonChip 
          class="p-2" 
          color="teal" 
          >
          {hour.hour < 10 ? 0 : null}
          {hour.hour}
        </IonChip>
      </TimelineSeparator>
      <TimelineContent className="flex justify-center fullWidth">
        <IonButton 
          fill="clear"
          onClick={() => {
            if(create && setTimePicker) {
              setTimePicker(hour.hour)
            } else {
              const createWalk = {
                name: api.tr('walk'),
                placeName: '',
                description: '',
                lat: 59.3,
                lng: 17.93,
                zoom: 15,
                start: dayjs(selectedDay).set('hour', hour.hour).set('minute', 0).format('YYYY-MM-DD HH:mm' ),
                lengthMinutes: 60,
                teamId: null,
                address: "",
                category: "",
                invitedPersons: [],
                inviteOnly: false,
                availableTo: [],
                maxBookings: 1,
                hasCoordinates: true,
                hasTalk: true,
                visibility: 'offentlig',
              }
              goToPageWithState('/walk/time', createWalk)
            }
          }}
        >
          <IonIcon icon={addCircle}/>
        </IonButton>
      </TimelineContent> 
    </TimelineItem>
  </Timeline>
  }

  return (
    <>
    { hour.walks.length > 0 ? hourComp() : null }
    { events.length > 0 ? eventComp() : null }
    { hour.walks.length === 0 && events.length === 0 ? noEvent() : null }
    </>
  )
}

export default TimelineComponent
